import React from 'react';
import PropTypes from 'prop-types';
import Form from './Form';
import Notification from '@deporvillage/notification-component';
import { I18n, I18nContext } from '@deporvillage/utils-library-component';

import styles from './LoginForm.module.scss';

const Errors = {
    InvalidUserCredentials: 'INVALID_USER_CREDENTIALS',
    UserBlocked: 'USER_BLOCKED',
};

const Events = {
    ButtonLogin: 'login-button-login',
    LinkForgotPassword: 'login-link-forgot',
};

/* istanbul ignore next */
const scrollToBottom = (elem) =>
    elem.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'end' });

const LoginForm = ({ customerData, onChange, onLogin, onLoginClick, onFocus, error }) => {
    const { email, password } = customerData;

    const { translate } = React.useContext(I18nContext);

    const loginError = React.useRef(null);

    const handleOnChange = (input) => onChange && onChange(input, customerData);
    const handleOnFocus = (e) => onFocus && onFocus(e);
    const handleOnLogin = (e) => {
        e.preventDefault();
        onLogin && onLogin(customerData, Events.ButtonLogin);
    };
    const handleOnLoginClick = (e) => {
        e.preventDefault();
        onLoginClick && onLoginClick(Events.LinkForgotPassword)
    };

    const handleErrorByType = (type) => {
        switch (type) {
            case Errors.InvalidUserCredentials:
                return (
                    <Notification
                        message={<I18n>header.login_from.errors.generic</I18n>}
                        type='error'
                    />
                );
            case Errors.UserBlocked:
                return (
                    <Notification
                        message={
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: translate('header.login_from.errors.error429'),
                                }}
                            />
                        }
                        type='error'
                    />
                );
            default:
                return (
                    <Notification
                        message={<I18n>header.login_from.errors.generic</I18n>}
                        type='error'
                    />
                );
        }
    };

    React.useEffect(() => {
        if (error && loginError.current) {
            scrollToBottom(loginError.current);
        }
    }, [error]);

    return (
        <div className={styles['login-form-component']}>
            <form autoComplete={'off'} className={styles['form-component']} id={'login-form'}>
                <div className={styles['title-form']}>
                    <I18n>header.login_from.sign_in</I18n>
                </div>
                <Form
                    {...email}
                    onChange={(value) => handleOnChange({ ...email, value })}
                    onFocus={handleOnFocus}
                />
                <Form
                    {...password}
                    onChange={(value) => handleOnChange({ ...password, value })}
                    onFocus={handleOnFocus}
                />
                <span
                    className={styles['forgotten']}
                    onClick={handleOnLoginClick}
                >
                    <I18n>header.login_from.forgot_password</I18n>
                </span>
                <button onClick={handleOnLogin} className={styles['button']}>
                    <I18n>header.login_from.sign_in</I18n>
                </button>
            </form>
            {error ? (
                <div ref={loginError} className={styles['login-error']}>
                    {handleErrorByType(error)}
                </div>
            ) : null}
        </div>
    );
};

LoginForm.propTypes = {
    customerData: PropTypes.shape({
        email: PropTypes.shape({
            id: PropTypes.string,
            type: PropTypes.string,
            label: PropTypes.string,
            value: PropTypes.string,
            error: PropTypes.string,
            validate: PropTypes.array,
        }),
        password: PropTypes.shape({
            id: PropTypes.string,
            type: PropTypes.string,
            label: PropTypes.string,
            value: PropTypes.string,
            error: PropTypes.string,
            validate: PropTypes.array,
        }),
    }),
    onLogin: PropTypes.func,
    onChange: PropTypes.func,
    onLoginClick: PropTypes.func,
    onFocus: PropTypes.func,
    error: PropTypes.string,
};

export default LoginForm;
